export const EXCHANGE_OPTIONS = [
  { value: 'ALL', label: 'All' },
  { value: 'NSE', label: 'Cash NSE' },
  { value: 'BSE', label: 'Cash BSE' },
  { value: 'NFO', label: 'Derivative NFO' },
  { value: 'BFO', label: 'Derivative BFO' },
  { value: 'MCX', label: 'Commodities' },
  { value: 'CDS', label: 'Forex' },
  { value: 'DCSX', label: 'Crypto' },
];

// Module-level so the hook receives a stable reference across renders.
export const PNL_FILTER_DEFS = [
  {
    key: 'exchange',
    label: 'Exchange',
    default: 'ALL',
    displayFn: (val) => EXCHANGE_OPTIONS.find((opt) => opt.value === val)?.label || val,
  },
];
